<div class="global-notification-popup">
  <form [formGroup]="notificationForm" class="notification-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Message de la notification</mat-label>
      <textarea
        matInput
        formControlName="message"
        placeholder="Saisissez votre message..."
        rows="4"
        maxlength="255">
      </textarea>
      <mat-hint align="end">{{ messageControl?.value?.length || 0 }}/255</mat-hint>
      <mat-error *ngIf="messageControl?.invalid && messageControl?.touched">
        {{ messageErrorText }}
      </mat-error>
    </mat-form-field>
  </form>
</div>